import { useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { LandingPage } from "./pages/LandingPage";
import { ApplyPage } from "./pages/ApplyPage";
import { ReviewPage } from "./pages/ReviewPage";
import { LoginPage } from "./pages/LoginPage";
import { AuthCallbackPage } from "./pages/AuthCallbackPage";
import { DashboardPage } from "./pages/DashboardPage";
import { AdminPage } from "./pages/AdminPage";
import { LegalPage } from "./pages/LegalPage";
import { GuardianPage } from "./pages/GuardianPage";
import { DataRequestPage } from "./pages/DataRequestPage";
import { RouteGuard } from "./components/RouteGuard";
import { ProvingGroundPage } from "./pages/ProvingGroundPage";
import { LeaderboardPage } from "./pages/LeaderboardPage";
import { TrainingPage } from "./pages/TrainingPage";
import { EarningsPage } from "./pages/EarningsPage";
import { TeamPage } from "./pages/TeamPage";
import { PayoutAdminPage } from "./pages/PayoutAdminPage";
import { PayoutGuardianPage } from "./pages/PayoutGuardianPage";
import { WorkflowAdminPage } from "./pages/WorkflowAdminPage";
import { AdminCellsPage } from "./pages/AdminCellsPage";
import { AdminQaPage } from "./pages/AdminQaPage";
import { NotFoundPage } from "./pages/NotFoundPage";

function LegacyHashBridge() {
  const navigate = useNavigate();
  useEffect(() => {
    const hash = window.location.hash;
    if (!hash.startsWith("#/")) return;
    const target = hash.slice(1);
    window.history.replaceState(null, "", target);
    navigate(target, { replace: true });
  }, [navigate]);
  return null;
}

export default function App() {
  return (
    <>
      <LegacyHashBridge />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/apply" element={<ApplyPage />} />
        <Route path="/review/:token" element={<ReviewPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
        <Route path="/guardian/:token" element={<GuardianPage />} />
        <Route path="/payout/guardian/:token" element={<PayoutGuardianPage />} />
        <Route path="/app" element={<RouteGuard><DashboardPage /></RouteGuard>} />
        <Route path="/app/proving" element={<RouteGuard><ProvingGroundPage /></RouteGuard>} />
        <Route path="/app/leaderboard" element={<RouteGuard><LeaderboardPage /></RouteGuard>} />
        <Route path="/app/training" element={<RouteGuard><TrainingPage /></RouteGuard>} />
        <Route path="/app/earnings" element={<RouteGuard><EarningsPage /></RouteGuard>} />
        <Route path="/app/team" element={<RouteGuard><TeamPage /></RouteGuard>} />
        <Route path="/admin/payouts" element={<RouteGuard admin><PayoutAdminPage /></RouteGuard>} />
        <Route path="/admin/workflows" element={<RouteGuard admin><WorkflowAdminPage /></RouteGuard>} />
        <Route path="/admin/cells" element={<RouteGuard admin><AdminCellsPage /></RouteGuard>} />
        <Route path="/admin/qa" element={<RouteGuard admin><AdminQaPage /></RouteGuard>} />
        <Route path="/admin/*" element={<RouteGuard admin><AdminPage /></RouteGuard>} />
        <Route path="/legal/:document" element={<LegalPage />} />
        <Route path="/data-request/:type" element={<DataRequestPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}
